/**
 * @param paramName
 * @returns
 */
export function getLocationSearch(): string {
  return window.location.search;
}

export function getQueryParam(paramName: string): string | null {
  const search = getLocationSearch();
  const params = new URLSearchParams(search);
  return params.get(paramName);
}

export function getTmsTenantId(): number {
  const tenantIdFromUrl = getQueryParam('selectedTenant');
  if (tenantIdFromUrl && !isNaN(Number(tenantIdFromUrl))) {
    const tenantId = Number(tenantIdFromUrl);
    localStorage.setItem('tenant_id', tenantId.toString());
    return tenantId;
  }
  return Number(localStorage.getItem('tenant_id')) || 0;
}
export const tmsConfig = {
  baseUrlUI: '/',
  logger: 'console',
  wms: {
    baseUrlUI: '/',
    wmsJreportBaseUrl: 'https://lflreportdev.lfuat.net',
    wmsJreportBaseUat: 'https://lflreport.lfuat.net',
    wmsJreportBaseProd: 'https://report.lflogistics.net',
    wmsUat: 'sceuat.lflogistics.net',
    wmsProd: 'sce.lflogistics.net',
    commonApiBaseUrl: '../',
    wmsJreportBaseProdAmericas:
      'https://americas-logireport.fulfillment.maersk.com',
    wmsJreportBaseProdAsia: 'https://asia-logireport.fulfillment.maersk.com',
    wmsJreportBaseProdEur: 'https://europe-logireport.fulfillment.maersk.com',
    wmsJreportBaseCdt: 'https://cdt-logireport.fulfillment.maersk.com',
    wmsProdAmericas: 'americas-wms.fulfillment.maersk.com',
    wmsProdAsia: 'asia-wms.fulfillment.maersk.com',
    wmsProdEur: 'europe-wms.fulfillment.maersk.com',
    wmsCdt: 'cdt-wms.fulfillment.maersk.com',
  },
  gvt: {
    baseUrlUI: '/gvt',
    gvtApiBaseUrl: '../gvtcommon/',
  },
  dashboard: {
    baseUrlUI: '/dashboard',
    dashboardApiBaseUrl: '../dashboardservice/',
  },
  tms: {
    // baseUrl: 'http://222.65.28.22:38080',
    // baseUrl: 'https://fleet.dispatcher-uat.lflogistics.net',
    baseUrl: 'https://dispatcher-dev.lflogistics.net/api',
    userPreferences: `/htms/v1/${getTmsTenantId()}/user-preference`,
    getUserInfoUri: '/iam/v1/sync/users/getUserInfos',
    menuQueryUri: 'iam/hzero/v1/menus/tree',
    shipmentQueryUri: `/htms/v2/${getTmsTenantId()}/shipments/queryShipments`,
    newshipmentQueryUri: `/htms/v2/${getTmsTenantId()}/shipments/matchQueryShipments`,
    /** UWP-61780 All Shipments list: POST body same shape as queryShipments fields. */
    shipmentListQueryUri: `/htms/v2/${getTmsTenantId()}/shipments/queryShipmentList`,
    shipmentListExportUri: `/htms/v2/${getTmsTenantId()}/shipments/queryShipmentList/export`,
    shipmentListExportSuUri: `/htms/v2/${getTmsTenantId()}/shipments/queryShipmentList/export/SU`,
    carrierShipmentCountUri: `/htms/v2/${getTmsTenantId()}/shipments/queryCount`,
    // shipment-planning or shipment-finalized
    shipmentPlanningQuery: `/htms/v1/${getTmsTenantId()}/search-conditions/queryShipment`, // 通用查询接口
    shipmentSaveCondtion: `/htms/v1/${getTmsTenantId()}/search-conditions/saveCondition`, // 查询条件保存接口
    shipmentLoadCondtion: `/htms/v1/${getTmsTenantId()}/search-conditions/queryCondition`, // 查询条件加载接口
    shipmentPlanningOrderQuery: `/htms/v2/${getTmsTenantId()}/shipments/queryRelatedOrder`, // 关联订单查询接口
    shipmentPlanningUnplanQuery: `/htms/v2/${getTmsTenantId()}/shipments/queryUnplannedOrder`, // 未关联订单查询接口
    shipmentPlanningFinalized: `/htms/v2/${getTmsTenantId()}/shipments/batchSaveNew/finalize`, // 运单finalize接口
    shipmentPlanningChildOrder: `/htms/v2/${getTmsTenantId()}/shipments/queryRelatedOrderByStop`, // 查询站点的order数据
    shipmentBatchDropOrder: `/htms/v2/${getTmsTenantId()}/shipments/batchDropOrder`, // 拖动order数据进行取消关联
    shipmentBatchDragOrder: `/htms/v2/${getTmsTenantId()}/shipments/batchDragOrder`, // 拖动order数据进行关联
    shipmentAddPickupDropOrder: `/htms/v2/${getTmsTenantId()}/shipments/batchCancelOrder`,
    shipmentAddPickupDragOrder: `/htms/v2/${getTmsTenantId()}/shipments/batchaddOrder`,
    shipmentDriverInfo: `/htms/v2/${getTmsTenantId()}/shipments/getDriverInfo`, // 获取司机信息
    shipmentGetRoutes: `/htms/v2/${getTmsTenantId()}/shipments/getRoutes`, // 获取画线
    shipmentGpsMobileRputes: `/htms/v2/${getTmsTenantId()}/shipments/heartbeat/routes`, //获取gps/MOBILE画线
    shipmentDoRoutes: `/htms/v2/${getTmsTenantId()}/shipments/doRoutes`, // 前端变更画线
    shipmentDoResequence: `/htms/v2/${getTmsTenantId()}/shipments/doResequence`, // 前端拖拽排序
    shipmentRelatedOrderByStop: `/htms/v2/${getTmsTenantId()}/shipments/queryRelatedOrderByStop`, // 查询stop关联的order
    shipmentPlanningUnFinalized: `/htms/v2/${getTmsTenantId()}/shipments/batchSaveNew/unfinalize`, // 运单unfinalize接口
    shipmentMapUpdate: `/htms/v2/${getTmsTenantId()}/shipments/batchSaveNew/update`, // 拖拽地图后保存更新信息
    shipmentBatchUpdateFields: `/htms/v2/${getTmsTenantId()}/shipments/batchUpdateFields`,
    getBusinessUnitGid: `/htms/v2/${getTmsTenantId()}/shipments/getBusinessUnitGid/`, // 获取GId
    queryEquipmentsInfo: `/htms/v2/${getTmsTenantId()}/shipments/queryEquipmentsInfo/`, // 获取司机车辆信息
    assigndriver: `/htms/v2/${getTmsTenantId()}/shipments/batchSaveNew/assigndriver`, // 分配司机
    unassigndriver: `/htms/v2/${getTmsTenantId()}/shipments/batchSaveNew/unassigndriver`, // 取消分配司机
    shipmentEXTransfer: `/htms/v2/${getTmsTenantId()}/shipments/batchSaveNew/transfer`, // 重新分配司机
    shipmentEXCancelTransfer: `/htms/v2/${getTmsTenantId()}/shipments/batchSaveNew/canceltransfer`, // 取消重新分配司机
    submitLocationUri: `/htms/v1/${getTmsTenantId()}/basic/location/submit`,
    shipmentNewUpDate: `/htms/v1/${getTmsTenantId()}/locationVariances/saveLocationFront`, // 更新update地址
    submitResetPassword: `/htms/v1/${getTmsTenantId()}/basic/driver/passwordReset`,
    deleteShipment: `/htms/v2/${getTmsTenantId()}/shipments/delShipment`,
    queryCallingCode: `/htms/v2/${getTmsTenantId()}/shipments/queryCallingCode/`,
    queryLocationHeartbeat: `/htms/v2/${getTmsTenantId()}/shipments/queryLocationHeartbeat`, // heartbeat 功能
    exportShipment: `/htms/v2/${getTmsTenantId()}/shipments/export/`, // export
    truckClose: `/mobile/v1/${getTmsTenantId()}/truck-close`,
    getConsigneeContactInfo: `/htms/v2/${getTmsTenantId()}/shipments/getConsigneeContactInformationByStop`,
    skipConsigneeVer: `/htms/v2/${getTmsTenantId()}/shipments/skipConsigneeVerification`,
    getretriggerOpt: `/htms/v2/${getTmsTenantId()}/shipments/retriggerOtp`,
    updateShipmentDetail: `/htms/v1/${getTmsTenantId()}/shipmentDetail/updateShipmentDetail`,

    // Trip Planning
    tripPlanningQuery: `/htms/v1/${getTmsTenantId()}/search-conditions/queryTripPlanning/`,
    tripDetail: `/htms/v2/${getTmsTenantId()}/shipments/trips/`,
    queryTripDetail: `/htms/v1/${getTmsTenantId()}/trips/`,
    carrierLOV: `/htms/v1/${getTmsTenantId()}/trips/trip-builder/lov/carrier/`,
    truckTypeLOV: `/htms/v1/${getTmsTenantId()}/trips/trip-builder/lov/truck-type/`,
    tripFinalize: `/htms/v2/${getTmsTenantId()}/shipments/trips/finalize`,
    tripUnfinalize: `/htms/v2/${getTmsTenantId()}/shipments/trips/unfinalize`,
    tripTender: `/htms/v2/${getTmsTenantId()}/shipments/trips/tender`,
    tripExport: `/htms/v2/${getTmsTenantId()}/shipments/trips/export`,
    tripChildShipmentQuery: `/htms/v1/${getTmsTenantId()}/trips/`,
    tripStopInfo: `/htms/v2/${getTmsTenantId()}/shipments/trips/`,
    tripRoute: `/htms/v2/${getTmsTenantId()}/shipments/getRoutes`,
    assignDriver: `/htms/v2/${getTmsTenantId()}/trips/`,
    tripBuilderShipmentPool: `/htms/v1/${getTmsTenantId()}/trips/trip-builder/shipment-pool/query`,
    tripBuilderContextInit: `/htms/v1/${getTmsTenantId()}/trips/trip-builder/context/init`,
    tripBuilderResequence: `/htms/v1/${getTmsTenantId()}/trips/trip-builder/resequence`,
    tripBuilderCreate: `/htms/v1/${getTmsTenantId()}/trips/trip-builder/create/`,
    tripBuilderSave: `/htms/v1/${getTmsTenantId()}/trips/trip-builder/trips/`,
    unassignWarning: `/htms/v2/${getTmsTenantId()}/shipments/trips/unassign-driver/warnings`,

    //carrier trip booking dashboard
    queryCarrierTripBookings: `/htms/v2/${getTmsTenantId()}/shipments/queryCarrierTripBookings/`,
    carrierTripAction: `/htms/v2/${getTmsTenantId()}/shipments/carrier/trips/`,

    //controlTower
    safetyReportExportUri: `/htms/v1/${getTmsTenantId()}/shipment-event-history/export/`,
    safetyReportQueryUri: `/htms/v1/${getTmsTenantId()}/shipment-event-history/search-conditions`,
    controlTowerOrderDetailUri: `/order/api/v1/${getTmsTenantId()}/order-movement/selectDetail`, // controlTower orderID调用地图
    controlTowerQueryUri: `/order/api/v1/${getTmsTenantId()}/order-movement/selectOrders`, //controlTower列表查询接口
    newcontrolTowerQueryUri: `/order/api/v1/${getTmsTenantId()}/order-movement/selectOrdersByCondition`, //controlTower列表查询接口
    locationQueryUri: `/htms/v1/${getTmsTenantId()}/basic/location/query`,
    locationSearchQueryUri: `/htms/v1/${getTmsTenantId()}/basic/location/searchWithKeyword`,
    truckBanQueryURI: `/htms/v1/${getTmsTenantId()}/truck-ban-rules/location`,
    truckBanCreateURI: `/htms/v1/${getTmsTenantId()}/truck-ban-rules`,
    specialServicesURI: `/htms/v1/${getTmsTenantId()}/special-services`,
    serviceAttributesQueryURI: `/htms/v1/${getTmsTenantId()}/service-attributes/query`,

    controlTowerEventTrackingQueryUri: `/tower/v1/${getTmsTenantId()}/dds/queryEventTrackings`,
    controlTowerArrivedRateQueryUri: `/order/api/v1/${getTmsTenantId()}/order-movement/selectArrivedRate`, //KDI 饼图
    controlTowerPodQueryUri: `/order/api/v1/${getTmsTenantId()}/order-movement/selectPod`,
    controlTowerShipmentQueryUri: `/htms/v2/${getTmsTenantId()}/shipments/dashboard/shipmentCount`,
    controlTowerOrderQueryUri: `/htms/v2/${getTmsTenantId()}/shipments/dashboard/orderCount`,
    controlTowerRateDetailsQueryUri: `/tower/v1/${getTmsTenantId()}/dds/selectRateDetails`, //饼图详情页
    // selectOrdersByXidNew: '/tower/api/order/dds/selectOrdersByXidNew', //加密页面
    selectOrdersByXidNew: `/order/api/v1/${getTmsTenantId()}/order-movement/selectOrdersByXidNew`, //加密页面
    selectBusinessUnit: `/tower/api/order/dds/selectBusinessUnit`,
    selectPrompt: `/order/api/v1/${getTmsTenantId()}/order-movement/selectPrompt`,
    controlTowerServiceReportQueryUrl: `/htms/v1/${getTmsTenantId()}/search-conditions/driver-hoss`,
    serviceReportExport: `/htms/v1/${getTmsTenantId()}/driver-hoss/export/`,
    fleetMonitoringQuery: `/htms/v1/${getTmsTenantId()}/search-conditions/vehicles-monitoring`,
    fleetMonitoringHeartbeat: `/htms/v1/${getTmsTenantId()}/vehicles/gps/heartbeat`,
    fleetMonitoringUnpair: '/htms/v1/0/shipment-pairing/unpair',
    fleetSearchQuery: `/htms/v1/${getTmsTenantId()}/basic/equipment/query`,
    fleetExportUri: `/htms/v1/${getTmsTenantId()}/driver-temps/export/fleet/`,

    // mass-upload
    queryMassUpload: `/htms/v1/${getTmsTenantId()}/mass-upload-pod/queryOrder`, //查询列表
    queryDetailMassUpload: `/htms/v1/${getTmsTenantId()}/mass-upload-pod/getOrderDetails`, //查询详情页面
    queryHistoryMassUpload: `/htms/v1/${getTmsTenantId()}/mass-upload-pod/getEventTrackings`, //历史查询
    massFileUpload: `/htms/v1/${getTmsTenantId()}/mass-upload-pod/upload`, //单文件上传
    massBatchFileUpload: `/htms/v1/${getTmsTenantId()}/mass-upload-pod/batchUpload`, //批量上传
    massSaveFileUpload: `/htms/v1/${getTmsTenantId()}/mass-upload-pod/batchSave`, //批量上传保存
    massHistoryFileUpload: `/htms/v1/${getTmsTenantId()}/mass-upload-pod//getEventTrackings`, //查看历史操作数据
    queryPrincial: `/htms/v1/${getTmsTenantId()}/mass-upload-pod/getP`, //查询值集
    // truckClose: '/mobile/v1/0/truck-close',
    //push-notification
    saveNotification: `/htms/v1/${getTmsTenantId()}/notification/save`, // save
    queryUser: `/htms/v1/${getTmsTenantId()}/notification/query`,
    // system-setting
    queryStatus: `/htms/v1/${getTmsTenantId()}/countrySetting/statusList`,
    queryReason: `/htms/v1/${getTmsTenantId()}/countrySetting/reasonList`,
    submitSetting: `/htms/v1/${getTmsTenantId()}/countrySetting/submitSetting`,
    querySystemSetting: `/htms/v1/${getTmsTenantId()}/countrySetting/list`,
    deleteSetting: `/htms/v1/${getTmsTenantId()}/usermanuals/removeUsermanuals`,
    uploadSetting: `/htms/v1/${getTmsTenantId()}/usermanuals/upload`,
    uploadOrderEvent: `/order/api/v1/${getTmsTenantId()}/order-movement/event/upload/excel`,
    uploaddriverEvent: `/htms/v2/${getTmsTenantId()}/shipments/driver/upload/excel`,
    downloadOrderEvent: `/order/api/v1/${getTmsTenantId()}/order-movement/event/download/excel`,
    downloadSetting: `/htms/v1/${getTmsTenantId()}/usermanuals/download`,
    getPDFStatus: `/htms/v1/${getTmsTenantId()}/basic/operationRecord/queryReport`,
    getPDFBussiness: `/htms/v1/${getTmsTenantId()}/basic/operationRecord/queryBusiness`,
    getPdfUrl: `/htms/v1/${getTmsTenantId()}/basic/operationRecord/getPdfUrl`,
    getNewPdfUrl: `/htms/v1/${getTmsTenantId()}/basic/operationRecord/getPdfUrlNew`,
    taskListType: '/hpfm/v1/lovs/value',
    getPDFQueryReport: `/htms/v1/${getTmsTenantId()}/basic/operationRecord/queryReportConfig`,
    getPDFQueryReportURL: `/htms/v1/${getTmsTenantId()}/basic/operationRecord/generateReportByConfig`,

    // child-template
    queryTemplateList: `/notification/v1/${getTmsTenantId()}/template/list`,
    templateAdd: `/notification/v1/${getTmsTenantId()}/template/add`, // template add
    templateUpdate: `/notification/v1/${getTmsTenantId()}/template/update`, // template update
    templateDelete: `/notification/v1/${getTmsTenantId()}/template/deletetemplate`, // template delete
    queryTemplate: `/notification/v1/${getTmsTenantId()}/template/details`, // query detail
    queryPanner: `/notification/v1/${getTmsTenantId()}/template/getallpartner`, // query Panner
    queryPlaceholder: `/notification/v1/${getTmsTenantId()}/template/getallplaceholders`,
    queryThirdData: `/htms/v1/${getTmsTenantId()}/third-party-scan-headers/getList`,
    downThirdData: `/mobile/v1/${getTmsTenantId()}/third-party-scan-headers/exportExcel`,
    importQueryUri: `/htms/v1/${getTmsTenantId()}/import/data`,
    importDataUri: `/htms/v1/${getTmsTenantId()}/import/data/data-import`,
    importUploadUri: `/htms/v1/${getTmsTenantId()}/import/data/data-upload`,
    importVerifyUri: `/htms/v1/${getTmsTenantId()}/import/data/data-validate`,
    importHistoryUri: `/htms/v1/${getTmsTenantId()}/import/manager`,
    templateDownloadUri: `/htms/v1/${getTmsTenantId()}/import/template/{}/excel`,
    templateUploadUri: `/htms/v1/${getTmsTenantId()}/import/data/data-upload`,
    orderQueryUri: `/htms/v1/${getTmsTenantId()}/movement/queryAllNewOrderList`,
    orderDtlQueryUri: `/htms/v2/${getTmsTenantId()}/shipments/queryAllOrderList`,
    // orderDtlQueryUri: '/htms/v1/0/htms/movement/queryAllOrderList',
    lovQueryUri: '/htms/v1/lovs/sql/data',
    codeValueQueryUri: '/hpfm/v1/lovs/value',
    excuteMacroUri: `/htms/v1/${getTmsTenantId()}/tp/macro/excuteMacro`,
    updateMacroUri: `/htms/v2/${getTmsTenantId()}/shipments/update/shipment`,
    equipmentQueryUri: `/htms/v2/${getTmsTenantId()}/shipments/queryEquipments`,
    equipmentGroupQueryUri: `/htms/v1/${getTmsTenantId()}/basic/equipment/group/query`, // 获取车辆类型
    equipmentGroupSubmitUri: `/htms/v1/${getTmsTenantId()}/basic/equipment/group/submit`,
    driverQueryUri: `/htms/v1/${getTmsTenantId()}/basic/driver/query`, // 获取司机信息
    driverBasicQueryUri: `/htms/v1/${getTmsTenantId()}/basic/driver/driverSummary`,
    driverDetailQueryUri: `/htms/v1/${getTmsTenantId()}/basic/driver/query`,
    driverAuditLogQuery: `/htms/v1/${getTmsTenantId()}/driver/auditLogs/search`,
    auditLogQuery: `/htms/v1/${getTmsTenantId()}/driver/auditLogs/query`,
    driverDetailExport: `/htms/v1/${getTmsTenantId()}/driver-temps/export/`,
    driverSubmitUri: `/htms/v1/${getTmsTenantId()}/basic/driver/submit`,
    driverImTypeUri: `/htms/v1/${getTmsTenantId()}/driver/qualifications/imType`,
    driverQualificationTypesUri: `/htms/v1/${getTmsTenantId()}/service-attributes/query`,
    driverQualificationCreateUri: `/htms/v1/${getTmsTenantId()}/driver/qualifications/create`,
    driverQualificationUpdateUri: `/htms/v1/${getTmsTenantId()}/driver/qualifications/update`,
    driverQualificationDeleteUri: `/htms/v1/${getTmsTenantId()}/driver/qualifications/delete`,
    driverQualificationQueryUri: `/htms/v1/${getTmsTenantId()}/driver/qualifications/driver`,
    driverImportSample: `htms/v1/${getTmsTenantId()}/basic/driver/import/template/download`,
    driverImportUrl: `htms/v1/${getTmsTenantId()}/basic/driver/import`,
    fleetImportSample: `htms/v1/${getTmsTenantId()}/basic/equipment/group/import/template/download`,
    fleetImportUrl: `htms/v1/${getTmsTenantId()}/basic/equipment/group/import`,
    truckQualificationTypesUri: `/htms/v1/${getTmsTenantId()}/service-attributes/query`,
    truckQualificationCreateUri: `/htms/v1/${getTmsTenantId()}/basic/equipment/qualifications/create`,
    truckQualificationUpdateUri: `/htms/v1/${getTmsTenantId()}/basic/equipment/qualifications/update`,
    truckQualificationDeleteUri: `/htms/v1/${getTmsTenantId()}/basic/equipment/qualifications/delete`,
    truckQualificationQueryUri: `/htms/v1/${getTmsTenantId()}/basic/equipment/qualifications/equipment`,
    locationCertificationSearchUri: `/htms/v1/${getTmsTenantId()}/basic/location/search`,
    carrierQueryUri: `/htms/v1/${getTmsTenantId()}/basic/servprov/query`,
    carrierQueryUriALL: `/htms/v1/${getTmsTenantId()}/basic/servprov/queryAll`,
    carrierSubmitUri: `/htms/v1/${getTmsTenantId()}/basic/servprov/submit`,
    queryTruckUri: `/htms/v1/${getTmsTenantId()}/basic/equipment/query`,
    customerQueryUri: `/htms/v1/${getTmsTenantId()}/basic/customer/query`,
    customerSubmitUri: `/htms/v1/${getTmsTenantId()}/basic/customer/submit`,
    opRecordQueryUri: `/htms/v1/${getTmsTenantId()}/basic/operationRecord/queryOperationRecord`,
    orderRouteCheckUri: `/htms/v2/${getTmsTenantId()}/shipments/dataCheck`,
    shipmentCountUri: `/htms/v2/${getTmsTenantId()}/shipments/queryCountShimpment`,
    shipmentEventHistoryListUri: `/kmq/v1/${getTmsTenantId()}/goods/api`,
    queryTruckDetailUri: `/htms/v1/${getTmsTenantId()}/basic/equipment/`,
    submitTruckUri: `/htms/v1/${getTmsTenantId()}/equipment-temps/submit`,
    submitTruckStatusUri: `/htms/v1/${getTmsTenantId()}/basic/equipment/equipmentSubmitStatus`,
    saveEventUri: `/htms/v2/${getTmsTenantId()}/blackCardBoard/saveEvent`,
    getAllShipmentId: `/htms/v1/${getTmsTenantId()}/basic/operationRecord/queryOperationRecord`,
    getAllOrderId: `/htms/v1/${getTmsTenantId()}/basic/operationRecord/queryOrderRecord`,
    getKpiOrderList: `/htms/v2/${getTmsTenantId()}/shipments/dashboard/orderList`,
    getKpiShipmentList: `/htms/v2/${getTmsTenantId()}/shipments/dashboard/shipmentList`,
    exportKpiOrderList: `/htms/v2/${getTmsTenantId()}/shipments/order/export`,
    exportKpiShipmentList: `/htms/v2/${getTmsTenantId()}/shipments/shipment/export`,
  },
  order: {
    orderEventQuery: `/order/api/v1/${getTmsTenantId()}/order-movement/event/listPage`,
    orderProcessingQuery: `/order/api/v1/${getTmsTenantId()}/order-movement/processing/listPage`,
    allOrderQuery: `/order/api/v1/${getTmsTenantId()}/order-movement/all/listPage`,
    orderAllExport: `/order/api/v1/${getTmsTenantId()}/order-movement/all/export/`,
    orderProcessingExport: `/order/api/v1/${getTmsTenantId()}/order-movement/processing/export/`,
    allOrderDelete: `/order/api/v1/${getTmsTenantId()}/order-movement/processing/delete`,
    orderQueryDetail: `/order/api/v1/${getTmsTenantId()}/order-movement/processing/listPage`,
    orderEventExportSelect: `/order/api/v1/${getTmsTenantId()}/order-movement/event/filterExport/`,
    orderEventImport: `/order/api/v1/${getTmsTenantId()}/order-movement/bulkUpdate`,
    orderEventImportStatus: `/order/api/v1/${getTmsTenantId()}/order-movement/bulkUpdate/status`,
    downloadOrderEventTemplate: `/order/api/v1/${getTmsTenantId()}/order-movement/update/download/excel`,
  },
  report: {
    inboundQuery: `/htms/v1/${getTmsTenantId()}/invoke-inbounds/listPage`,
    outboundQuery: `/htms/v1/${getTmsTenantId()}/invoke-outbounds/listPage`,
    locationQuery: `/htms/v1/${getTmsTenantId()}/locationVariances/listPage`,
    handoverQuery: `/htms/v1/${getTmsTenantId()}/handed-overs/list`,
    pushevent: `/htms/v2/${getTmsTenantId()}/shipments/pushevent`,
    checklistReportQuery: `/htms/v1/${getTmsTenantId()}/checklist-report`,
    getReasonCode: `/htms/v1/${getTmsTenantId()}/invoke-outbounds/getReasonCode`,
    stopDwellingQuery: `/htms/v2/${getTmsTenantId()}/shipments/stop/dwelling/search`,
    stopDwellingExport: `/htms/v2/${getTmsTenantId()}/shipments/stop/dwelling/report/excel/`,
    stationPullReport: `/htms/v1/${getTmsTenantId()}/station-pull-report/`,
  },
  settings: {
    reasonCodeQuery: `/htms/v1/${getTmsTenantId()}/statusAndCode/list`,
    commodityQuery: `/htms/v1/${getTmsTenantId()}/basic/commodity/query`,
    saveCheckQuery: `/htms/v1/${getTmsTenantId()}/task/list`,
    transportQuery: `/htms/v1/${getTmsTenantId()}/basic/transport-handlings/query`,
    getAccessrialCodeList: `/htms/v1/${getTmsTenantId()}/basic/accessorial/query`,
    getAccessrialDetail: `/htms/v1/${getTmsTenantId()}/basic/accessorial/queryDetail`,
    getAccessrialClassList: `/htms/v1/${getTmsTenantId()}/basic/accessorial/queryClass`,
    setAccessrialAddClass: `/htms/v1/${getTmsTenantId()}/basic/accessorial/addClass`,
    accessrialDeleteClass: `/htms/v1/${getTmsTenantId()}/basic/accessorial/deleteClass`,
    getProductCodeList: `/htms/v1/${getTmsTenantId()}/basic/serviceClassification/query`,
    getProductDetail: `/htms/v1/${getTmsTenantId()}/basic/serviceClassification/queryDetail`,
    setProductAddClass: `/htms/v1/${getTmsTenantId()}/basic/serviceClassification/createServiceClassification`,
    productDeleteClass: `/htms/v1/${getTmsTenantId()}/basic/serviceClassification/deleteServiceClassification`,
  },
  notification: {
    serverconfigurationQuery: `/notification/v1/${getTmsTenantId()}/serverMaster/list`,
    viewMessagesQuery: `/notification/v1/${getTmsTenantId()}/dashboard/list`,
    alertpreview: `/notification/v1/${getTmsTenantId()}/template/alertpreview`,
    getTemplateCategory: `/notification/v1/${getTmsTenantId()}/master/getcategorybylkcode`,
    getTemplatePlaceholders: `/notification/v1/${getTmsTenantId()}/template/getallplaceholders`,
    getTemplatePartner: `/notification/v1/${getTmsTenantId()}/template/getallpartner`,
    getTemplateCountry: `/notification/v1/${getTmsTenantId()}/template/getallcountry`,
    setSmsplaceholder: `/notification/v1/${getTmsTenantId()}/template/addsmsplaceholder`,
    getallmastertemplate: `/notification/v1/${getTmsTenantId()}/template/getallmastertemplate`,
    retryrerun: `/notification/v1/${getTmsTenantId()}/dashboard/retryrerun`,
    dashboardExport: `/notification/v1/${getTmsTenantId()}/dashboard/export`,
    smsSuccessQuery: `/notification/v1/${getTmsTenantId()}/dashboard/smsSuccessFailedCount`,
    emailSuccessQuery: `/notification/v1/${getTmsTenantId()}/dashboard/emailSuccessFailedCount`,
    getTemplateType: `/notification/v1/${getTmsTenantId()}/content/getFileTemplates`,
    downloadTemplate: `/notification/v1/${getTmsTenantId()}/content/downloadTemplate`,
    importTemplateFile: `/notification/v1/${getTmsTenantId()}/content/importFile`,
    queryWorkflow: `/notification/v1/${getTmsTenantId()}/workFlow/getworkflowcontrolfront`,
    getsystemworkflow: `/notification/v1/${getTmsTenantId()}/workFlow/getsystemworkflow`,
    queryTables: `/notification/v1/${getTmsTenantId()}/workFlow/searchTables`,
    getworkflowcontrol: `/notification/v1/${getTmsTenantId()}/workFlow/getworkflowcontrol`,
    getUniqueWorkflowControl: `/notification/v1/${getTmsTenantId()}/template/uniqueWorkflowControl`,
    saveworkflowcontrol: `/notification/v1/${getTmsTenantId()}/workFlow/saveworkflowcontrol`,
    deleteworkflowcontrolbyid: `/notification/v1/${getTmsTenantId()}/workFlow/deleteworkflowcontrolbyid`,
    getManageEventlist: `/notification/v1/${getTmsTenantId()}/template/getallsuggestionrules`,
    getOffsetStages: `/notification/v1/${getTmsTenantId()}/template/getOffsetStages`,
    getRecipient: `/notification/v1/${getTmsTenantId()}/template/getRecipient`,
    getalleventname: `/notification/v1/${getTmsTenantId()}/template/getalleventname`,
    getviewtemplate: `/notification/v1/${getTmsTenantId()}/template/viewtemplate`,
    getvalidateOffsetStageEnd: `/notification/v1/${getTmsTenantId()}/template/validateOffsetStageEnd`,
    saveeventworkflow: `/notification/v1/${getTmsTenantId()}/template/saveeventworkflow`,
    editeventworkflow: `/notification/v1/${getTmsTenantId()}/template/editeventworkflow`,
    saveSuggestionRuleData: `/notification/v1/${getTmsTenantId()}/template/saveSuggestionRuleData`,
    getWorkflowData: `/notification/v1/${getTmsTenantId()}/template/getWorkflowData`,
    geteventbyeventid: `/notification/v1/${getTmsTenantId()}/template/geteventbyeventid`,
    deleteworkflowbyeventid: `/notification/v1/${getTmsTenantId()}/template/deleteworkflowbyeventid`,
    saveTSMasterParamName: `/notification/v1/${getTmsTenantId()}/template/saveplaceholder`,
    deleteTSMasterParamName: `/notification/v1/${getTmsTenantId()}/template/deleteplaceholder`,
    insertHtml: `/notification/v1/${getTmsTenantId()}/template/getTableHtml`,
    deleteEvent: `/notification/v1/${getTmsTenantId()}/template/deleteSuggestionRuleData`,
  },
  blackcard: {
    queryParamCfg: `/htms/v1/${getTmsTenantId()}/parameters/getParameterInfo`,
    saveParamCfg: `/htms/v1/${getTmsTenantId()}/parameters/updateParameter`,
    getBingdingRecordUri: `/htms/v2/${getTmsTenantId()}/blackCardBoard/getBingdingRecord`,
    updateBingdingRecord: `/htms/v2/${getTmsTenantId()}/blackCardBoard/updateBingdingRecord`,
    getDeviceTotalSummaryUri: `/htms/v2/${getTmsTenantId()}/locatingInformations/getDeviceTotal`,
    getBlcInOutSttcsChrtUri: `/htms/v2/${getTmsTenantId()}/blackCardBoard/getReAndOther`,
    getBlackCardBoarUri: `/htms/v2/${getTmsTenantId()}/blackCardBoard/getBlackCardBoar`,
    getBlackBoardColorUri: `/htms/v2/${getTmsTenantId()}/blackCardBoard/getBlackBoardColor`,
    saveEventUri: `/htms/v2/${getTmsTenantId()}/blackCardBoard/saveEvent`,
    getNotificationUri: `/htms/v2/${getTmsTenantId()}/blackCardBoard/getNotification`,
    blackCardQueryUri: `/htms/v2/${getTmsTenantId()}/blackCardBoard/deviceQuery?deviceType=GPS`,
    deviceSimpleQueryUri: `/htms/v2/${getTmsTenantId()}/locatingInformations/getDeviceInfo`,
    checkBlackCardUseUri: `/htms/v2/${getTmsTenantId()}/locatingInformations/receiveCheck`,
    blackCardOpRecordQueryUri: `/htms/v2/${getTmsTenantId()}/tbl/deviceOperation/query`,
  },
  ajShipment: {
    ChangeCarrier: `/htms/v1/${getTmsTenantId()}/parameters/getParameterInfo`,
    MergeShipment: `/htms/v1/${getTmsTenantId()}/parameters/updateParameter`,
    SplitShipment: `/htms/v2/${getTmsTenantId()}/shipments/split/shipment`,
    ChangeTime: `/htms/v2/${getTmsTenantId()}/shipments/update/shipment/date`,
    getCarrierList: `/htms/v2/${getTmsTenantId()}/shipments/lov/carrier`,
    getTruckType: `/htms/v2/${getTmsTenantId()}/shipments/lov/truckType`,
    getCarrierPCT: `/htms/v2/${getTmsTenantId()}/shipments/change/truck/recalculate`,
    updateShipment: `/htms/v2/${getTmsTenantId()}/shipments/change/shipment`,
    mergeShipment: `/htms/v2/${getTmsTenantId()}/shipments/merge/shipment`,
    uploadShipment: `/htms/v2/${getTmsTenantId()}/shipments/event/upload/excel`,
    uploadShipmentStatus: `/htms/v2/${getTmsTenantId()}/shipments/event/upload/excel/status`,
    exportSU: `/htms/v2/${getTmsTenantId()}/shipments/export/SU`,
    downloadTemplate: `/htms/v2/${getTmsTenantId()}/shipments/event/download/excel`,
    downloadMassDriverTemplate: `/htms/v2/${getTmsTenantId()}/shipments/massDriver/download/excel`,
    swapShipment: `/htms/v2/${getTmsTenantId()}/shipments/event/upload/excel/swap`,
    downloadSwapTemplate: `/htms/v2/${getTmsTenantId()}/shipments/export/template/order-details`,
    swapShipmentStatus: `/htms/v2/${getTmsTenantId()}/shipments/event/upload/excel/swap/status`,
  },
  financials: {
    basicSurchargesQuery: `/htms/v1/${getTmsTenantId()}/basic/accessorial/query`,
    surchargesList: `/htms/v1/${getTmsTenantId()}/surcharges/list`,
    surchargesWithoutList: `/htms/v1/${getTmsTenantId()}/surcharges/without-surcharge/list`,
    surchargesDetail: `/htms/v1/${getTmsTenantId()}/surcharges/detail`,
    surchargesLines: `/htms/v1/${getTmsTenantId()}/surcharges/lines`,
    surchargesExportList: `/htms/v1/${getTmsTenantId()}/surcharges/export/lines`,
    surchargesExportNotStart: `/htms/v1/${getTmsTenantId()}/surcharges/export/not-start`,
    surchargesExportTemplate: `/htms/v1/${getTmsTenantId()}/surcharges/export/template`,
    surchargesImport: `/htms/v1/${getTmsTenantId()}/surcharges/import`,
    surchargesWorkflowSubmit: `/htms/v1/${getTmsTenantId()}/surcharges/workflow/submit`,
    surchargesWorkflowDeclareNoCosts: `/htms/v1/${getTmsTenantId()}/surcharges/workflow/declare-no-costs`,
    surchargesWorkflowApprove: `/htms/v1/${getTmsTenantId()}/surcharges/workflow/approve`,
    surchargesWorkflowReject: `/htms/v1/${getTmsTenantId()}/surcharges/workflow/reject`,
    surchargesWorkflowWithdraw: `/htms/v1/${getTmsTenantId()}/surcharges/workflow/withdraw-approval`,
  },
};
